<template>
  <div class="search-container">
    <vue-autosuggest
      :suggestions="suggestions"
      :input-props="{
        id: 'autosuggest__input',
        placeholder: 'Search for cheers or bitches',
        class: 'form-control'
      }"
      @input="onInputChange"
      @selected="onSelected"
      :get-suggestion-value="getSuggestionValue"
      v-model="query"
    >
      <template slot-scope="{ suggestion }">
        ({{ suggestion.item.type }})
        <span v-html="bolden(query, suggestion.item.text)" />
      </template>
    </vue-autosuggest>
  </div>
</template>

<script>
import axios from 'axios';
import { VueAutosuggest } from 'vue-autosuggest';

const IS_PRODUCTION = process.env.NODE_ENV === 'production';

const APIUrl = IS_PRODUCTION
  ? 'https://funtiny.appspot.com/'
  : 'http://localhost:5000';

export default {
  name: 'Search',
  data() {
    return {
      query: '',
      suggestions: [],
      timeout: null,
      debounceMilliseconds: 250
    };
  },
  methods: {
    bolden(text, suggestion) {
      const regex = new RegExp('(' + text + ')', 'gi');

      return suggestion.replace(regex, '<b>$1</b>');
    },
    search(query) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.suggestions = [];
        const path = `${APIUrl}/api/voices/search?q=${query}`;
        axios
          .get(path)
          .then(res => {
            // this.suggestions.push(res.data.map(d => d.text));
            this.suggestions.push({ name: 'hotels', data: res.data });
          })
          .catch(error => {
            // eslint-disable-next-line
            console.error(error);
          });
      }, this.debounceMilliseconds);
    },
    onInputChange(text) {
      if (text) this.search(text);
      else this.suggestions = [];
    },
    onSelected(item) {
      console.log(item.item);
      let adminQuery = {};
      if (this.$route.name == 'admin') {
        adminQuery = { query: { admin: true } };
      }
      this.$router.push({
        path: `/voice/${item.item.id}`,
        params: { id: item.item.id },
        ...adminQuery
      });
      this.query = '';
    },
    getSuggestionValue(suggestion) {
      const { type, text } = suggestion.item;
      return `(${type}) ${text}`;
    }
  },
  components: {
    VueAutosuggest
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.search-container {
  width: 80%;
  @media screen and (max-width: 480px) {
    width: 60%;
  }
}

#autosuggest__input {
  border: 1px solid #616161;
  box-sizing: border-box;
  display: block;
  float: right;
  height: 2.5rem;
  outline: none;
  padding: 10px;
  position: relative;
  width: 400px;
  @media screen and (max-width: 480px) {
    width: 90%;
  }
}

#autosuggest__input.autosuggest__input-open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
}

.autosuggest__results {
  background: white;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border: 1px solid #e0e0e0;
  max-height: 400px;
  overflow-y: scroll;
  position: absolute;
  right: 0;
  top: 2.5rem;
  z-index: 1000;
  width: 400px;
  @media screen and (max-width: 480px) {
    width: 90%;
  }

  ul {
    list-style: none;
    padding-left: 0;
    margin: 0;
  }

  .autosuggest__results-item {
    color: #000000bf !important;
    cursor: pointer;
    padding: 0 10px;
    line-height: 3;
    white-space: nowrap;

    b {
      color: #000000 !important;
    }
  }

  .autosuggest__results-item:active,
  .autosuggest__results-item:hover,
  .autosuggest__results-item:focus,
  .autosuggest__results-item.autosuggest__results-item--highlighted {
    background-color: #f6f6f6;
  }
}

#autosuggest ul:nth-child(1) > .autosuggest__results_title {
  border-top: none;
}
</style>
